import React from 'react';

export const ScrollToTopButton: React.FC = () => {
  // Handled inside unified FloatingActionHub
  return null;
};
